module.exports = __webpack_public_path__ + "media/images/flags/1x1/pcn-970d0ccfe11fe820998405a33258ab50.svg";